import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

const colorsClasses = {
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  grey: 'bg-primary-100 text-primary-700',
  orange: 'bg-yellow-100 text-yellow-700',
  blue: 'bg-blue-100 text-blue-700',
};

type StatusBadgeProps = {
  color: keyof typeof colorsClasses;
  children: ReactNode;
};

const StatusBadge: FC<StatusBadgeProps> = ({ color, children }) => {
  const commonClassName =
    'text-xs font-semibold inline-block py-0.5 px-2 rounded-full text-center';

  return (
    <div className={classNames(commonClassName, colorsClasses[color])}>
      {children}
    </div>
  );
};

export default StatusBadge;
